export const UPLOAD_TYPES = {
	DOWNLOAD: 1,
	UPLOAD: 2,
	SENDMAIL: 3,
	TESTMAIL: 4,
};
export const BASELINE_UPLOAD_TYPES = {
	UPLOAD_SPEND_OWNER: 1,
	UPLOAD_CURRENT_MODULE: 2,
};

export const LINK_TYPES = {
	baseline: 1,
	'preworkshop-template': 2,
	workshop: 3,
	'saving-sign-off': 4,
};
